var _rect, _title, _path, _circle, _path2, _path3, _path4, _circle2, _polygon, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressureModeMaxOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 123,
    viewBox: "0 0 209 123",
    enableBackground: "new 0 250 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M2.0000064697265714,104.50000659179688 c0,-56.609 45.891,-102.5 102.5,-102.5 s102.5,45.891 102.5,102.5 ",
    id: "svg_1",
    className: ""
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 103.51300048828125,
    cy: 100.86001586914062,
    r: 22.194000244140625,
    id: "svg_2",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    d: "M2.0000064697265714,104.50000659179688 c0,-56.609 45.891,-102.5 102.5,-102.5 s102.5,45.891 102.5,102.5 ",
    id: "svg_3",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aaaaaa",
    strokeWidth: 6,
    d: "M103.81600646972657,30.9100065917969 c3.214,0 6.3790000000000004,0.19800000000000004 9.489,0.5850000000000001 c36.806,4.559 65.493,35.295 66.862,73 ",
    id: "svg_4",
    className: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c0c0c0",
    strokeWidth: 6,
    d: "M27.46000646972655,104.50000659179688 c1.371,-37.905 30.354,-68.765 67.438,-73.074 c2.926,-0.3410000000000001 5.9030000000000005,-0.516 8.918,-0.516 ",
    id: "svg_5",
    className: ""
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCCCCC",
    cx: 103.51300048828125,
    cy: 100.86001586914062,
    r: 14.309000015258789,
    id: "svg_6",
    className: ""
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CCCCCC",
    points: "105.03599548339844,90.02801513671875 177.00502014160156,60.402008056640625 113.85499572753906,103.80801391601562 ",
    id: "svg_7",
    className: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAAAAA",
    d: "M177.00500646972654,60.40200659179686 l-86.584,46.359 c3.649,8.833 13.509,10.71 20.314,6.69 c4.582,-2.706 7.091,-7.569 7.019,-12.535 L177.00500646972654,60.40200659179686 z",
    id: "svg_8",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureModeMaxOff);
export default __webpack_public_path__ + "static/media/PressureModeMaxOff.1abf5d42.svg";
export { ForwardRef as ReactComponent };